import gsap from 'gsap';

export default class WideArea {

    constructor() {
        this.$widearea = document.querySelector('.js-widearea');
        this.scrollingTimer = null;
        this.isScrolling = false;
        this.$slidewrap = document.querySelector('.js-slidewrap');
        this.slideTimelines = [];
        this._init();
    }

    _init() {
        
        // ループギャラリー (スクロールで動く)
        this._initScrollEvents();

        // 一定時間ごとに背景カラーを差し替える
        setTimeout(() => {
            this._bgColorChange();
        }, 20000);

        // アニメーションの初期設定
        this._initAnimations();
    }

    _initAnimations(){

        document.querySelectorAll('.widearea__slide').forEach(($slide, index) => {
            const $inner = $slide.querySelector('.widearea__slide__inner');
            const direction = index === 1 ? 4715 : -4715;

            const tl = gsap.timeline({ repeat: -1, paused: true });
            tl.to($inner, {
                x: direction,
                duration: 60,
                ease: 'linear',
            });

            this.slideTimelines.push(tl);
        });
    }

    _initScrollEvents() {

        window.addEventListener('scroll', () => {
            
            if(!this.isScrolling){
                this._startAutoplay();
                this.isScrolling = true;
            }

            clearTimeout(this.scrollingTimer);

            this.scrollingTimer = setTimeout(() => {
                this._smoothStopAutoplay();
                document.body.classList.remove('-scrolling');
                this.isScrolling = false;
            }, 150);
        });
    }

    _startAutoplay() {
        if (this.$slidewrap.getAttribute('data-slide') === 'running') return;
        this.$slidewrap.setAttribute('data-slide', 'running');
        this.slideTimelines.forEach(tl => {
            tl.resume();
            gsap.to(tl, { timeScale: 1, duration: 0.3, ease: 'power1.inOut' });
        });
    }

    _smoothStopAutoplay() {
        if(this.$slidewrap.getAttribute('data-slide') === 'paused') return;
        this.$slidewrap.setAttribute('data-slide', 'paused');
        this.slideTimelines.forEach(tl => {
            gsap.to(tl, {
                timeScale: 0,
                duration: 0.7,
                ease: 'power1.out',
                onComplete: () => tl.pause()
            });
        });
    }

    _bgColorChange() {
        const mode = this.$widearea.getAttribute('data-mode');

        if (mode === '' || mode === 'pink') {
            this.$widearea.setAttribute('data-mode', 'purple');
        } else {
            this.$widearea.setAttribute('data-mode', 'pink');
        }

        setTimeout(() => {
            this._bgColorChange();
        }, 20000);
    }
}
